import React from 'react';
import Utils from '../utils';

const { Session } = Utils;

export const LearningCenterArticleLink = ({ linkText, stamps, endicia }) => {
	const { brandName } = Session.getBrand();

	return (
		<div className="common-article-external-link">
			<a
				className="article-link"
				role="button"
				tabIndex="0"
				onClick={() =>
					window.open(
						`https://help.${
							brandName === 'Stamps.com' ? 'stamps' : 'endicia'
						}.com/hc/en-us/articles/${brandName === 'Stamps.com' ? stamps : endicia}`
					)
				}
			>
				{linkText}
			</a>
			<span className="external-link-nav" />
		</div>
	);
};
